import styles from './index.module.scss';
import { useText } from './useText';
import getLocal from '@/app/utils/getLocal';

export default function Comp() {
    const { locale } = getLocal();
    const items = useText(locale);

    return (
        <div className={styles.comp}>
            {/* <div className="title">{t('head1')}</div> */}
            <section className="content eco-content">
                {items.map((item, ind) => (
                    <div className="item" key={ind} dangerouslySetInnerHTML={{ __html: item }}></div>
                ))}
            </section>
        </div>
    );
}
